import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// Inbound MN-CMS messages (MN-CMS → GP, msgtype 58) for a pregnancy, with their
// review/sign-off state and the correction flag (see MncmsInboundMessageDTO).
export const useMncmsInboundMessages = (pregnancyId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant") ?? "";

  return useQuery({
    queryKey: ["mncmsInboundMessages", pregnancyId, tenantVal],
    queryFn: async () => {
      const axios = createAxiosInstance();
      const response = await axios.get(
        `${tenantVal}/mncms/inbound-messages/pregnancy/${pregnancyId}`
      );

      return response.data?.data ?? response.data;
    },
    enabled: !!pregnancyId && !!tenantVal,
  });
};
